/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2019-05-23.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2019-05-23.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2019-05-23.mdx';

const metadata = {
  slug: "2019-05-23",
  title: "Fleeting Thoughts and Fitness",
  author: "Christian Battaglia",
  description: "Treadmill sprints, intermittent fasting brain fog, fleeting thoughts on meditation, and the creative sparks that hide in the depths. Written between sprint phases at the gym.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  headerImage: "/assets-cdbattaglia/media/meanderings/meanderings.jpg",
  date: "2019-05-23T00:00:00.000Z",
  
  readTime: "8 min read",
  tags: ["meanderings","fitness","meditation","intermittent fasting","Rust","Python","VST","Ardour","open source","podcasts"],
};

export const Route = createFileRoute('/blog/posts/2019-05-23')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2019-05-23',
    image: '/og/blog/2019-05-23.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
